/**
 * Builds a route by replacing parameter placeholders with actual values.
 * This provides type-safe route construction and eliminates manual string replacement.
 *
 * @param route - The route template with parameter placeholders (e.g., "/users/:userId/posts/:postId")
 * @param params - Object containing parameter values to substitute
 * @returns The constructed route with parameters replaced
 *
 * @example
 * buildRoute('/users/:userId/posts/:postId', { userId: 123, postId: 456 })
 * // Returns: "/users/123/posts/456"
 *
 * @example
 * buildRoute('/tenants/:tenantId', { tenantId: '789' })
 * // Returns: "/tenants/789"
 */
export const buildRoute = (
  route: string,
  params: Record<string, string | number>
): string => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    const encoded = encodeURIComponent(String(value));
    return acc.replaceAll(`:${key}`, encoded);
  }, route);
};
